<template>
  <div>
    SIGN DOCUMENT
    <hr>
    <b-form-group :class="{'error-input' : $v.data_sign_document.title.$error}">
      <label> Sign Document Title </label>
      <j-input
        v-model="$v.data_sign_document.title.$model"
        :max-length="255"
        placeholder="Sign Document Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeSignDocument">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveSignDocument">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_sign_document: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_sign_document: {
        title: '',
      },
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_channel']),

    generateDataSignDocument() {
      const infoName = this.data_sign_document.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_sign_document.title,
        widget_master_id: this.dataMaster.id,

        type: 3,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataSignDocumentUpdate() {
      const infoName = this.data_sign_document.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_sign_document.title,
        widget_master_id: this.dataMaster.id,

        type: 3,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_sign_document.title = JSON.parse(this.dataEdit.info).name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveSignDocument() {
      this.$v.data_sign_document.$touch();
      if (!this.$v.data_sign_document.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataSignDocument;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataSignDocumentUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeSignDocument();
      }
    },

    closeSignDocument() {
      this.$emit('close-field');
      this.data_sign_document.title = null;
      setTimeout(() => {
        this.$v.data_sign_document.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jSignDocumentSetup.vue